export default __webpack_public_path__ + "static/Oxygen-Complete-Fact-Sheet-2-November-2022-75fd809ff4c042d942e458eb94c555b7.pdf";